import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import OffsidebarRun from './Offsidebar.run';
import { Router, Route, Link, History } from 'react-router';
import { Translate, Localize } from 'react-redux-i18n';

class Offsidebar extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            key: 1
        };
    }

    componentDidMount() {
        OffsidebarRun();
    }

    handleSelect(key) {
        this.setState({
            key
        });
    }

    render() {
        const tabIconA = <em className="icon-equalizer fa-lg"></em>;
        const tabIconB = <em className="icon-user fa-lg"></em>;
        return (
            <aside className="offsidebar hide">
                { /* START Off Sidebar (right) */ }
                <Tabs activeKey={ this.state.key } onSelect={ this.handleSelect.bind(this) } justified>
                    <Tab eventKey={ 1 } title={ tabIconA }>
                        <Link to="/warehouse"><h3 data-toggle-state="offsidebar-open" className="text-center text-thin"><Translate value="warehouse_dashboard" /></h3></Link>
                        <Link to="/sales"><h3 data-toggle-state="offsidebar-open" className="text-center text-thin"><Translate value="sales_dashboard" /></h3></Link>
                        <Link to="/purchase"><h3 data-toggle-state="offsidebar-open" className="text-center text-thin"><Translate value="purchase_dashboard" /></h3></Link>
                        <Link to="/purchaseManagerDashboard"><h3 data-toggle-state="offsidebar-open" className="text-center text-thin"><Translate value="purchase_manager" /></h3></Link>
                        <Link to="/presidentDashboard"><h3 data-toggle-state="offsidebar-open" className="text-center text-thin"><Translate value="president_dashboard" /></h3></Link>
                    </Tab>
                </Tabs>
                { /* END Off Sidebar (right) */ }
            </aside>
            );
    }

}

export default Offsidebar;



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/Offsidebar.jsx